import { useCallback, useState, useEffect } from 'react';

export const useInput = ({
  initialState,
  errorText,
  invalidHandler,
}) => {
  const [value, setValue] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);

  const onChange = useCallback((event) => {
    setValue(event.target.value);
    setErrorMessage('');
    const isValidValue = invalidHandler(event.target.value);

    if (isValidValue) {
      setIsValid(true);
    }
  }, [invalidHandler]);

  useEffect(() => {
    if (initialState) {
      setValue(initialState);
    }
  }, [initialState]);

  const onBlur = useCallback(
    (event) => {
      const isValidValue = invalidHandler(event.target.value);
      const inValidMessage = isValidValue ? '' : errorText;

      setErrorMessage(inValidMessage);
      setIsValid(inValidMessage.length === 0);
    },
    [errorText, invalidHandler],
  );

  return {
    value,
    errorMessage,
    isValid,
    onChange,
    onBlur,
    setErrorMessage,
    setValue,
  };
};
